import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import React, { useEffect, useState } from "react"
import Button from "../../../shared/components/atoms/button/button"
import ArticleTestResponse from "../article-test-response/article-test-response"
import "./article-test.scss"

const ArticleTest = props => {
  const { slugPrefix } = props
  const [pageLoad, setPageLoad] = useState(false)
  const [response, setResponse] = useState(false)
  const [dataResponse, setDataResponse] = useState(props.answers[0])
  const [answers, setAnswers] = useState(() => {
    var arr = []
    for (let i = 0; i < props.questions.length; i++) {
      arr.push("a")
    }
    return arr
  })

  const handleSetAnswer = (answer, index) => {
    var auxAnswer = answers
    auxAnswer[index] = answer
    setAnswers([...auxAnswer])
  }

  const handleBackText = () => {
    window.scroll(0, 0)
    setResponse(false)
  }

  const sentAnswers = () => {
    var a = 0
    var b = 0
    var c = 0
    for (let i = 0; i < answers.length; i++) {
      switch (answers[i]) {
        case "a":
          a++
          break
        case "b":
          b++
          break
        case "c":
          c++
          break

        default:
          break
      }
    }
    if (a >= b && a >= c) {
      setDataResponse(props.answers[0])
    } else if (b >= a && b >= c) {
      setDataResponse(props.answers[1])
    } else {
      setDataResponse(props.answers[2])
    }
    setResponse(true)
  }

  useEffect(() => {
    setPageLoad(true)
  }, [])

  return (
    <div className="f-article-body">
      {!response && (
        <>
          {props.contentArticle !== null && (
            <span className="f-box-mobile">
              {documentToReactComponents(props.contentArticle.json)}
            </span>
          )}
          {props.questions.map((question, index) => {
            return (
              <div className="f-article-test" key={index}>
                <p className="f-article-test-question">
                  {question.preguntaGeneral}
                </p>
                <div className="f-article-test-answers">
                  {question.primeraAfirmacion && (
                    <div className="f-article-test-answers-text">
                      <div
                        className={answers[index] === "a" ? "aciveAnswer" : ""}
                        onClick={() => handleSetAnswer("a", index)}
                      >
                        <p>{question.primeraAfirmacion}</p>
                      </div>
                      <div
                        className={answers[index] === "b" ? "aciveAnswer" : ""}
                        onClick={() => handleSetAnswer("b", index)}
                      >
                        <p>{question.segundaAfirmacion}</p>
                      </div>
                      <div
                        className={answers[index] === "c" ? "aciveAnswer" : ""}
                        onClick={() => handleSetAnswer("c", index)}
                      >
                        <p>{question.terceraAfirmacion}</p>
                      </div>
                    </div>
                  )}
                  {question.primeraImagen && (
                    <div className="f-article-test-answers-img">
                      <div
                        className={answers[index] === "a" ? "aciveAnswer" : ""}
                        onClick={() => handleSetAnswer("a", index)}
                      >
                        <img
                          alt={question.primeraImagen.description}
                          src={
                            pageLoad
                              ? question.primeraImagen.file.url
                              : question.primeraImagen.fixed.base64
                          }
                        />
                      </div>
                      <div
                        className={answers[index] === "b" ? "aciveAnswer" : ""}
                        onClick={() => handleSetAnswer("b", index)}
                      >
                        <img
                          alt={question.segundaImagen.description}
                          src={
                            pageLoad
                              ? question.segundaImagen.file.url
                              : question.segundaImagen.fixed.base64
                          }
                        />
                      </div>
                      <div
                        className={answers[index] === "c" ? "aciveAnswer" : ""}
                        onClick={() => handleSetAnswer("c", index)}
                      >
                        <img
                          alt={question.terceraImagen.description}
                          src={
                            pageLoad
                              ? question.terceraImagen.file.url
                              : question.terceraImagen.fixed.base64
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
          <div className="f-article-test-send-answer" onClick={sentAnswers}>
            <Button className="primary-pink" title="Enviar resultados" />
          </div>

          <div className="f-page-buttons-container">
            {props.prevPag !== null && (
              <a href={slugPrefix + props.prevPag.slug}>
                <div className="f-option f-prev-option">
                  <span className="f-text-action">Anterior artículo</span>

                  <div className="f-icon-action-container f-container-icon-left">
                    <span className="f-icon icon-right f-icon-left" />
                  </div>
                </div>
              </a>
            )}
            {props.nextPag !== null && (
              <a href={slugPrefix + props.nextPag.slug}>
                <div className="f-option f-next-option">
                  <div className="f-icon-action-container ">
                    <span className="f-icon icon-right f-icon-right" />
                  </div>
                  <span className="f-text-action">Siguiente artículo</span>
                </div>
              </a>
            )}
          </div>
        </>
      )}
      {response && (
        <ArticleTestResponse
          mobile={props.mobile}
          dataResponse={dataResponse}
          handleBackText={handleBackText}
        />
      )}
    </div>
  )
}

export default ArticleTest
